export class TestDto {
  id: number;
  titleKr: string;
  titleEn: string;
  createdAt: string;
  updatedAt: string;
  isViewable: boolean;
}
